import React, { useEffect, useState } from 'react'
import DatePicker from 'react-date-picker'
import DateIcon from 'src/assets/Content-Icons/dateicon'
import TimePicker from 'src/components/timePicker/timePicker'
import { concatDateTimeToIso } from 'src/views/utils/helper'
import DeleteIcon from 'src/assets/iptv-delete-icon.svg'
import { isEmpty } from 'lodash'
import { CFormSelect } from '@coreui/react'

const repeatOptions = [
  {
    label: 'Daily',
    value: 'DAILY',
  },
  {
    label: 'Weekly once',
    value: 'WEEKLY',
  },
  {
    label: 'Monthly once',
    value: 'MONTHLY',
  },
]

const CampaignScheduleCard = ({ index, data, setScheduleData, scheduleData, onDelete }) => {
  const [startDate, setStartDate] = useState(new Date())
  const [startTime, setStartTime] = useState()
  // ending datetime for a channel content
  const [endDate, setEndDate] = useState(new Date())
  const [endTime, setEndTime] = useState()

  const [scheduleObj, setScheduleObj] = useState({
    start_date: '',
    end_date: '',
    frequency: 'DAILY',
  })

  useEffect(() => {
    if (!isEmpty(data)) {
      setScheduleObj(data)
      if (data?.start_date) {
        setStartDate(new Date(data['start_date']))
        setStartTime(
          new Date(data['start_date']).toLocaleTimeString('en-UK', {
            timeStyle: 'short',
            hour12: false,
          }),
        )
      }
      if (data?.end_date) {
        setEndDate(new Date(data['end_date']))
        setEndTime(
          new Date(data['end_date']).toLocaleTimeString('en-UK', {
            timeStyle: 'short',
            hour12: false,
          }),
        )
      }
    }
  }, [data])

  //   useEffect(() => {
  //     if (!isEmpty(scheduleObj) && scheduleObj.frequency) {
  //       let tempSlots = [...scheduleData]
  //       tempSlots[index] = scheduleObj
  //       setScheduleData(tempSlots)
  //     }
  //   }, [scheduleObj])

  const updateScheduleData = (obj) => {
    let tempSlots = [...scheduleData]
    tempSlots[index] = obj
    setScheduleData(tempSlots)
  }

  const handleDateChange = (value, stateFunc, timeState, channelKey) => {
    stateFunc(value)
    let tempObj = scheduleObj
    tempObj[channelKey] = concatDateTimeToIso(value, timeState)
    setScheduleObj({ ...tempObj })
    updateScheduleData({ ...tempObj })
  }

  const handleTimeChange = (value, stateFunc, dateState, channelKey) => {
    stateFunc(value)
    let tempObj = scheduleObj
    tempObj[channelKey] = concatDateTimeToIso(dateState, value)
    setScheduleObj({ ...tempObj })
    updateScheduleData({ ...tempObj })
  }
  const handleRecurring = (event) => {
    let tempObj = scheduleObj
    tempObj['frequency'] = event.target.value
    setScheduleObj({ ...tempObj })
    updateScheduleData({ ...tempObj })
  }

  return (
    <div
      className="slot d-flex justify-between relative rounded w-100"
      style={{
        background: '#f8f8f8',
        height: '6vw',
        padding: '0.9vw',
        marginBottom: '.75vw',
        border: `2px solid #84848480`,
      }}
    >
      <div
        className=" text-center d-flex align-items-center h-100"
        style={{ width: '8%', borderRight: '1.5px solid #70707080' }}
      >
        <h6 style={{ fontSize: '.8333vw' }} className="mb-0">
          Schedule {index + 1}
        </h6>
      </div>
      <div style={{ width: '91%' }} className="d-flex align-items-center">
        <div className="d-flex justify-between w-100" style={{}}>
          <div className="d-flex w-75">
            <div>
              <h6 className="mb-0" style={{ fontSize: '.65vw' }}>
                START TIME<span className="asterisk ">*</span>
              </h6>
              <div className="d-flex">
                <div>
                  <DatePicker
                    className="date-picker-pricing"
                    // onChange={setStartDate}
                    onChange={(value) =>
                      handleDateChange(value, setStartDate, startTime, 'start_date')
                    }
                    value={startDate}
                    minDate={startDate ? '' : new Date()}
                    format="dd/MM/y"
                    calendarIcon={<DateIcon />}
                  />
                </div>
                <div style={{ marginLeft: '.5vw', position: 'relative' }}>
                  <TimePicker
                    time={startTime}
                    // setTime={setStartTime}
                    setTime={(value) =>
                      handleTimeChange(value, setStartTime, startDate, 'start_date')
                    }
                    customFontSize={'max(.65vw,9px)'}
                    customPadding={'.86vw .25vw'}
                    customWidth={'15ch'}
                  />
                </div>
              </div>
            </div>
            <div style={{ marginLeft: '1.5vw' }}>
              <h6 className="mb-0" style={{ fontSize: '.65vw' }}>
                END TIME<span className="asterisk">*</span>
              </h6>
              <div className="d-flex">
                <div>
                  <DatePicker
                    className="date-picker-pricing"
                    // onChange={setEndDate}
                    onChange={(value) => handleDateChange(value, setEndDate, endTime, 'end_date')}
                    value={endDate}
                    minDate={startDate}
                    format="dd/MM/y"
                    calendarIcon={<DateIcon />}
                  />
                </div>
                <div style={{ marginLeft: '.5vw', position: 'relative' }}>
                  <TimePicker
                    time={endTime}
                    // setTime={setEndTime}
                    setTime={(value) => handleTimeChange(value, setEndTime, endDate, 'end_date')}
                    customFontSize={'max(.65vw,9px)'}
                    customPadding={'.86vw .25vw'}
                    customWidth={'15ch'}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-between w-25">
            <div
              style={{
                fontSize: '.65vw',
                // marginLeft: '1.5vw',
                width: '7.5vw',
              }}
            >
              <h6 className="mb-0" style={{ fontSize: '.65vw' }}>
                Set Recurring
              </h6>
              <CFormSelect
                value={scheduleObj.frequency}
                onChange={(e) => handleRecurring(e)}
                className=" w-100"
                size="sm"
              >
                {repeatOptions.map((option, idx) => (
                  <option value={option.value} key={idx}>
                    {option.label}
                  </option>
                ))}
              </CFormSelect>
            </div>
            <div
              //   style={{ width: '%' }}
              className=" d-flex justify-content-center align-items-center "
            >
              {index ? (
                <img
                  onClick={onDelete}
                  src={DeleteIcon}
                  style={{ width: '30px' }}
                  alt=""
                  className="h-100 cursor-pointer mt-2"
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CampaignScheduleCard
